import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';
import Modal from '@portalterreno/react-ui-core/Modal';

const StyledModal = styled(Modal)({
  [media('lg')]: {
    paddingLeft: 32,
    paddingRight: 32,
    paddingBottom: 20,
    width: 410
  },
  '& > div:last-of-type': {
    '& > div': {
      paddingTop: 0
    }
  },
  '& > div:nth-of-type(2) > div': {
    marginTop: 0
  }
});

export default StyledModal;
